import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { customTheme } from './assets/themes/CustomTheme';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from '@emotion/react';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={customTheme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();
